export function can(granted: string[], required: string): boolean {
  return granted.some(
    (permission) =>
      permission === required ||
      (permission.endsWith(':*') &&
        required.startsWith(permission.slice(0, -1))),
  )
}
